function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @class jobAndPhaseCodeFilter.
 *
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import entityComposition from '../common/classes/entityComposition';
import Loader from '../common/loader';
import TieredSelect from '../common/lookups/tieredSelect';
import searchFactory from '../common/lookups/searchFactory';
import pagerFactory from '../common/pagingTable/pagerFactory';
const JobSearch = searchFactory('jobAndPhaseCodeFilterReport');
const JobPager = pagerFactory('jobAndPhaseCodeFilterReport');

/**
 * data is coming back often in flat rows that we
 * need to build special hiearchical representations from.
 */
const makeTree = data => data.map(({
  jobID,
  jobNumber,
  phaseCodes
}) => ({
  entity: 'Job',
  filter: 'job',
  jobID,
  jobNumber,
  id: jobID,
  name: jobNumber,
  nodes: phaseCodes.map(({
    id,
    name
  }) => ({
    entity: 'JobPhaseCode',
    filter: 'jobphasecode',
    id,
    jobID,
    jobNumber,
    name,
    nodes: []
  }))
}));
class JobAndPhaseCodeFilter extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    const {
      jobAndPhaseCodeFilterReportActions,
      jobAndPhaseCodeFilterReportIndexQuery
    } = this.props;
    jobAndPhaseCodeFilterReportActions.serverIndex(jobAndPhaseCodeFilterReportIndexQuery);
  }
  handleChange(selectedValues, newValue) {
    const {
      reportActions,
      reportIndexQuery
    } = this.props;
    const filters = JSON.parse(JSON.stringify(reportIndexQuery.filters));
    let jobPhaseCode = filters.jobPhaseCode ? filters.jobPhaseCode : [];
    let job = filters.job ? filters.job : [];

    // remove if existing
    if (newValue.entity.toLowerCase() === 'jobphasecode') {
      if (jobPhaseCode.some(jpc => jpc.id === newValue.id)) {
        // remove this from the list
        jobPhaseCode = _.filter(jobPhaseCode, pc => pc.id !== newValue.id);
      } else {
        jobPhaseCode = jobPhaseCode.concat([{
          id: newValue.id,
          name: newValue.name,
          entity: newValue.entity
        }]);
      }
    } else if (newValue.entity.toLowerCase() === 'job') {
      if (job.some(j => j.id === newValue.id)) {
        // remove this from the list
        job = _.filter(job, j => j.id !== newValue.id);
      } else {
        job = job.concat([{
          id: newValue.id,
          name: newValue.name,
          entity: newValue.entity
        }]);
      }
    }
    reportActions.serverFilter(_objectSpread(_objectSpread({}, filters), {}, {
      jobPhaseCode,
      job
    }), reportIndexQuery);
  }
  render() {
    const {
      reportIndexQuery: {
        filters
      },
      jobAndPhaseCodeFilterReportOptions,
      onBack,
      jobAndPhaseCodeFilterReportLoading
    } = this.props;
    let selections = [];
    if (filters) {
      if (filters.jobPhaseCode) {
        selections = filters.jobPhaseCode;
      }
      if (filters.job) {
        selections = selections.concat(filters.job);
      }
    }
    return /*#__PURE__*/React.createElement("div", {
      style: {
        minHeight: 100
      }
    }, /*#__PURE__*/React.createElement(TieredSelect, {
      label: "Job",
      data: jobAndPhaseCodeFilterReportOptions,
      value: selections,
      nameOptions: ['jobNumber'],
      onBack: onBack,
      onChange: this.handleChange,
      backLabel: "Back"
    }, /*#__PURE__*/React.createElement(JobSearch, null), /*#__PURE__*/React.createElement(JobPager, null), /*#__PURE__*/React.createElement(Loader, {
      loaded: !jobAndPhaseCodeFilterReportLoading
    })));
  }
}
JobAndPhaseCodeFilter.propTypes = {
  reportIndexQuery: PropTypes.shape({
    filters: PropTypes.shape({
      job: PropTypes.arrayOf(PropTypes.shape({})),
      jobPhaseCode: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string
      }))
    })
  }).isRequired,
  jobAndPhaseCodeFilterReportIndexQuery: PropTypes.shape({
    filters: PropTypes.shape({})
  }).isRequired,
  jobAndPhaseCodeFilterReportOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  jobAndPhaseCodeFilterReportActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  jobAndPhaseCodeFilterReportLoading: PropTypes.bool.isRequired,
  onBack: PropTypes.func.isRequired,
  reportActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired
};
export { JobAndPhaseCodeFilter as TestJobAndPhaseCodeFilter, makeTree };
export default entityComposition(JobAndPhaseCodeFilter, [], {
  reportIndexQuery: state => state.report.indexQuery,
  jobAndPhaseCodeFilterReportOptions: state => makeTree(state.jobAndPhaseCodeFilterReport.list),
  jobAndPhaseCodeFilterReportLoading: state => state.jobAndPhaseCodeFilterReport.loading,
  jobAndPhaseCodeFilterReportIndexQuery: state => state.jobAndPhaseCodeFilterReport.indexQuery
}, ['jobAndPhaseCodeFilterReport', 'report']);